import { createAsyncThunk } from '@reduxjs/toolkit';
import { Notification } from '../../../clubhouse/models/notification';

export const addLikeToMessage = createAsyncThunk(
    'directMessages/like',
    (notification: Notification) => {
        return {
            message: notification.message,
            roomId: notification.chatId,
        };
    }
);
